import { selectBalancingCollectLeagueUnlockLevel } from "../balancingSelectors/selectBalancingConstants";
import { selectBalancingFarmEventById } from "../balancingSelectors/selectBalancingFarmEvents";
import { selectResourceInfo } from "../balancingSelectors/selectBalancingResources";
import { getResourceIcon } from "../features/generic/icon/getResourceIcon";
import { selectEventInfoByTypeId, selectIsEventRunning } from "./selectEventInfo";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectCollectEvents = function (state) {
    return state.eventInfo.collectEvent || [];
};
export var selectActiveCollectEvent = function (state) {
    var events = selectCollectEvents(state);
    return events.find(function (event) {
        var isEventWellFormatted = event.eventId != undefined && event.typeId != undefined;
        var isEventRunning = selectIsEventRunning(event);
        return isEventWellFormatted && isEventRunning;
    });
};
export var selectCloserCollectEvent = function (state) {
    var events = selectCollectEvents(state);
    return events.find(function (event) { return event.eventId != undefined && event.typeId != undefined; });
};
export var selectActiveCollectEventBalancingInfo = function (state) {
    var foundEvent = selectActiveCollectEvent(state);
    if (foundEvent == undefined) {
        return;
    }
    return selectBalancingFarmEventById(foundEvent.typeId);
};
export var selectActiveCollectEventEventInfo = function (state) {
    var currentCollectEvent = selectActiveCollectEvent(state);
    var collectEventId = currentCollectEvent ? currentCollectEvent.typeId : undefined;
    return collectEventId ? selectEventInfoByTypeId(state, collectEventId) : undefined;
};
export var selectActiveCollectEventResource = function (state) {
    var activeEvent = selectActiveCollectEventBalancingInfo(state);
    if (activeEvent == undefined || activeEvent.bonusProduction == undefined) {
        return;
    }
    return selectResourceInfo(activeEvent.bonusProduction.resourceID);
};
export var selectActiveCollectEventIcon = function (state) {
    var resourceInfo = selectActiveCollectEventResource(state);
    if (resourceInfo == undefined) {
        return;
    }
    return getResourceIcon(resourceInfo);
};
export var selectIsCollectEventUnlocked = function (state) {
    var playerLevel = selectPlayerLevel(state);
    var unlockLevel = selectBalancingCollectLeagueUnlockLevel();
    return playerLevel >= unlockLevel;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectCollectEvents.ts
// module id = 292
// module chunks = 3